import { render, staticRenderFns } from "./LandedCostComponentListView.vue?vue&type=template&id=53440142"
import script from "./LandedCostComponentListView.vue?vue&type=script&lang=js"
export * from "./LandedCostComponentListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports